require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-العين-الثالثة.json") })
        }
      }, "path---tags-العين-الثالثة");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-العين-الثالثة!./.cache/json/tags-العين-الثالثة.json
// module id = 580
// module chunks = 231608221292675